module.exports = __webpack_public_path__ + "img/dreamstore_logo.cb440606.svg";